import i18next from 'i18next'

export const compareString = new Intl.Collator(i18next.language).compare

export function sortByDate<T>(
  array: Array<T>,
  getDate: (value: T) => Date | number | string,
  order: 'descending' | 'ascending' = 'ascending',
) {
  const modifier = order === 'descending' ? -1 : 1
  return array.sort(
    (a, b) => (+new Date(getDate(a)) - +new Date(getDate(b))) * modifier,
  )
}
